<template>
  <div>
    <div class="checkbox styled">
      <input
        :id="'score-set-' + scoreSet.id"
        type="checkbox"
        :checked="visible"
        @change="onChange"
      />
      <label :for="'score-set-' + scoreSet.id">
        {{ scoreSet.name }}
      </label>
    </div>
    <multiselect
      v-if="visible"
      :id="'attachment-types-' + scoreSet.id"
      name="attachmentTypes[]"
      :filter="false"
      :counter="false"
      :options="options"
      :selected-options="selectedOptions"
      :select-all-label="lang.get('multiselect.select_all')"
      @selected="onSelected"
    />
  </div>
</template>

<script>
import _ from 'underscore';
import { Multiselect } from 'vue-bootstrap';

export default {
  inject: ['lang'],
  components: {
    Multiselect
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    scoreSet: {
      type: Object,
      required: true
    },
    attachmentTypes: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: true,
      selectedOptions: []
    };
  },
  computed: {
    options() {
      return Object.keys(this.attachmentTypes || {}).map(key => ({
        id: key,
        name: this.attachmentTypes[key]
      }));
    }
  },
  created() {
    const types = this.category.attachmentTypes;
    const hasTypes = types && types.hasOwnProperty(this.scoreSet.id);

    this.visible = hasTypes;
    this.selectedOptions = hasTypes ? types[this.scoreSet.id] : [];
  },
  methods: {
    onSelected(options) {
      this.selectedOptions = options;
      this.inputEvent();
    },
    onChange(event) {
      this.visible = event.target.checked;
      this.inputEvent();
    },
    inputEvent() {
      const attachmentTypes = this.category.attachmentTypes || {};
      const types = {};

      if (this.visible && this.selectedOptions.length) {
        types[this.scoreSet.id] = [...this.selectedOptions];
      } else {
        types[this.scoreSet.id] = null;
      }

      this.$emit(
        'input',
        _.omit(
          {
            ...attachmentTypes,
            ...types
          },
          _.isNull
        )
      );
    }
  }
};
</script>
